import {Dispatch} from 'redux';
import {getDays, addDays} from '../../../utilities/helpers/date-helpers';
import * as actions from './actions';
import {ObservationV2} from '../../../api/api';
import {dmiClient} from '../api-clients';

export async function getPrecipPast1h(stationId: string, to: Date, from: Date) {
  return async (dispatch: Dispatch) => {
    dispatch(actions.getWeatherDatas.started({stationId, from, to}));
    try {
      let res: ObservationV2[] = [];
      let days = getDays(to, from);

      if (days > 30) {
        let fromDate: Date = from;
        let toDate: Date = addDays(fromDate, 30);

        // Fix only 1000 elements (approx 30 days) can be returned from DMI
        while (days > 0) {
          res = res.concat(
            await (dmiClient as any).getDmiApiPrecipitation(stationId, fromDate.toISOString(), toDate.toISOString()),
          );
          if (days < 30) {
            fromDate = toDate;
            toDate = addDays(toDate, days);
            days = 0;
          } else {
            days = days - 30;
            fromDate = toDate;
            toDate = addDays(toDate, 30);
          }
        }
      } else {
        res = await (dmiClient as any).getDmiApiPrecipitation(stationId, from.toISOString(), to.toISOString());
      }

      dispatch(actions.getWeatherDatas.done({result: res, params: {stationId, from, to}}));
    } catch (error) {
      dispatch(actions.getWeatherDatas.failed(error as any));
    }
  };
}
